const ContainerComponent = ({ children }: { children: JSX.Element } ) => {

    return (
        <div className="container-xl p-5">
            {children}
        </div>
    )

}

export default ContainerComponent;